import React from 'react'
import useOpenProfile from '../hooks/useOpenProfile'

/**
 * Кликабельные имя и аватар игрока — переход на /profile/:slug.
 *
 * Принимает slug игрока из ответа API (в кейсбатлах — user_slug) и весь
 * класс разметки оборачиваемого блока. При slug !== null блок получает
 * cursor-pointer и ведёт на экран профиля; при null рендерится как есть —
 * игрок удалён из базы или это демо-данные, элемент не кликабелен
 * и ничем не помечен.
 *
 * Рендерится <span>, а не <button>: аватары часто лежат внутри
 * кликабельных карточек-кнопок, а вложенные интерактивные элементы
 * запрещены HTML-спецификацией.
 */
const ProfileLink = ({ slug, className = '', children, ...rest }) => {
  const openProfile = useOpenProfile()

  return (
    <span
      onClick={slug ? (event) => openProfile(event, slug) : undefined}
      className={slug ? `${className} cursor-pointer transition-transform active:scale-[0.98]` : className}
      {...rest}
    >
      {children}
    </span>
  )
}

export default ProfileLink
